var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"block":"","type":"submit","color":"primary","disabled":_vm.disabled,"data-cy":"login-button"}},[_vm._t("default",[_vm._v("Login")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }